<template>
  <div class="alert-section">
    <el-alert
      :closable="false"
      :show-icon="false"
      type="info"
    >
      <template v-slot:title>
        <div class="alert-title-wrapper">
          <strong>{{ alertTitle }}</strong>
          <el-tooltip
            effect="dark"
            placement="bottom"
            class="help-tooltip mobile-only"
          >
            <template v-slot:content>
              <div class="tooltip-content">
                <p>To enable them to handle communications:</p>
                <ul>
                  <li>Assign a phone line to their user (creates a Personal Inbox)</li>
                  <li>Add them to an inbox as a member (creates a Connected Inbox)</li>
                  <li>Add them as a watcher to an inbox (creates a Watching Inbox)</li>
                </ul>
              </div>
            </template>
            <i class="el-icon-question help-icon"></i>
          </el-tooltip>
        </div>
      </template>
      <div class="alert-content desktop-only">
        <p class="mb-2">
          The following users don't have access to any Inbox. To enable them
          to handle communications:
        </p>
        <ul class="mb-0 d-inline-block text-left">
          <li>Assign a phone line to their user (creates a Personal Inbox)</li>
          <li>Add them to an inbox as a member (creates a Connected Inbox)</li>
          <li>Add them as a watcher to an inbox (creates a Watching Inbox)</li>
        </ul>
      </div>
    </el-alert>
  </div>
</template>

<script>
export default {
  name: 'TeamInboxAlertHeader',
  
  props: {
    userCount: {
      type: Number,
      required: true
    }
  },
  
  computed: {
    alertTitle() {
      if (this.userCount === 1) {
        return '1 user is not part of any inbox'
      }
      return `${this.userCount} users are not part of any inbox`
    }
  }
}
</script>

<style lang="scss" scoped>
.alert-section {
  padding: 20px;
  flex-shrink: 0;

  .el-alert {
    text-align: center;
    width: 100%;
    display: flex;
    
    ::v-deep .el-alert__content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
    }
    
    ::v-deep .el-alert__title {
      width: 100%;
      display: block;
      
      .alert-title-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        
        @media (max-width: 768px) {
          justify-content: space-between;
        }
      }
    }

    .help-icon {
      color: #909399;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        color: #66b1ff;
      }
    }
  }

  .alert-content {
    ul {
      text-align: left;
      padding-left: 20px;

      li {
        padding: 2px 0;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 15px;
  }
}

.mobile-only {
  display: none;
  
  @media (max-width: 768px) {
    display: inline-block;
  }
}

.desktop-only {
  display: block;
  
  @media (max-width: 768px) {
    display: none;
  }
}

.tooltip-content {
  max-width: 300px;

  p {
    margin: 0 0 8px;
  }

  ul {
    margin: 0;
    padding-left: 20px;

    li {
      padding: 2px 0;
    }
  }
}
</style>